import { ScoreDetailChartBox } from "src/components/ScoreDetail/Chart";
import { ChartMode, ScoreDetailChartData } from "src/components/ScoreDetail/Chart/chart.types";
import { ModalData } from "src/components/ScoreDetail/PropertyModal/PropertyModal";
import { Loading } from "src/components/utils/Loading";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { propertyActionRuleset } from "../Common/propertyActionRuleset";

type BySubheadingProps = {
    headingId: number;
    subheadingId: number;
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};
export const BySubheading = (props: BySubheadingProps) => {
    const { headingId, subheadingId, mode, openModal } = props;
    const { scoreDetailBuilder, drilldownState } = useScoreDetailContext();
    if (scoreDetailBuilder === undefined) {
        // This should be deleted
        return <Loading />;
    }

    const bySubheading = scoreDetailBuilder.getBySubheadingId({
        headingId: headingId,
        subheadingId: subheadingId,
    });
    if (bySubheading === null) return null;

    const items = bySubheading?.properties?.flatMap((property) => {
        const score = property.score;
        const isScoreVoid = score?.value === undefined || score?.value === null;
        const isScoreZero = score?.value === 0;
        if (isScoreVoid || isScoreZero) return [];
        if (property.score === null) return [];

        const action = propertyActionRuleset({
            property,
            mode,
            openModal,
            drilldown: drilldownState.drilldown,
        });
        const comparisonItem: ScoreDetailChartData = {
            title: property.property.name ?? property.property.title ?? "",
            score: property.score,
            action,
        };
        return [comparisonItem];
    });

    const total: ScoreDetailChartData = {
        title: "Total",
        score: bySubheading.total,
    };

    return <ScoreDetailChartBox data={items ?? []} total={total} mode={mode} />;
};
